import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  sdg: {
    background: 'white',
    color: '#041370',
    paddingLeft: '30px !important',

    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
      paddingLeft: '0px !important',
    },

    [theme.breakpoints.down('sm')]: {
      marginTop: '30px',
      paddingLeft: '0px !important',

    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '30px',
      paddingLeft: '0px !important',

    },

  },

  titleImpact: {
    fontFamily: 'MontserratBold',
    fontSize: '24px',
    fontWeight: 700,
    // lineHeight: '63px',
    marginBottom: 20,
    letterSpacing: '0em',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',

    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
    },


  },
  sdgData: {
    fontFamily: 'MontserratBold',
    fontSize: '40px',
    fontWeight: 700,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },

  },
  sdgTitle: {
    fontFamily: 'MontserratBold',
    fontSize: '24px',
    fontWeight: 700,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },

  },
  sdgContaienr: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '15px 0px 15px 0px',


  },
  sgDataRoot: {

  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
}));
export default useStyles;
